import { createAction } from "@reduxjs/toolkit";

import {
  clearPolicySettingsActionTypes,
  getPolicySettingsActionTypes,
  updatePolicySettingsActionTypes,
} from "./actionTypes";

export const getPolicySettings = createAction(
  getPolicySettingsActionTypes.request,
);

export const getPolicySettingsSuccess = createAction(
  getPolicySettingsActionTypes.success,
  (payload) => ({ payload }),
);

export const getPolicySettingsFailure = createAction(
  getPolicySettingsActionTypes.failure,
  (error) => ({ payload: error }),
);

export const updatePolicySettings = createAction(
  updatePolicySettingsActionTypes.request,
);

export const updatePolicySettingsSuccess = createAction(
  updatePolicySettingsActionTypes.success,
  (payload) => ({ payload }),
);

export const updatePolicySettingsFailure = createAction(
  updatePolicySettingsActionTypes.failure,
  (error) => ({ payload: error }),
);

export const clearPolicySettingsStates = createAction(
  clearPolicySettingsActionTypes.reset,
);
